import { BrandConfig } from '../../types/brand';

const brandConfig: BrandConfig = {
  name: "SW Democrats",
  logo: "/logo.svg",
  colors: {
    primary: {
      DEFAULT: '#1B3A5C',
      50: '#f0f5fa',
      100: '#dce6f0',
      200: '#b5cade',
      300: '#8aadcb',
      400: '#4f80a8',
      500: '#1B3A5C',
      600: '#163150',
      700: '#122943',
      800: '#0d2037',
      900: '#09172a',
    },
    secondary: {
      DEFAULT: '#e8733a',
      50: '#fef4ee',
      100: '#fde5d5',
      200: '#fbc9a9',
      300: '#f7a573',
      400: '#f28c52',
      500: '#e8733a',
      600: '#c95e2c',
      700: '#a84b23',
      800: '#873c1d',
      900: '#6c3018',
    }
  },
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseKey: import.meta.env.VITE_SUPABASE_KEY,
  
  // Contact Information
  contactEmail: "info@swvolusiademocrats.org",
  contactPhone: "(386) 853-1580",
  
  // Meeting Information
  nextMeetingDate: "2nd Thursday of the month",
  nextMeetingTime: "Doors open at 6:30 PM, Meeting at 7:00 PM",
  nextMeetingLocation: "Port Orange Regional Library",
  meetingFrequency: "monthly on the 2nd Thursday",

  socialLinks: {
    facebook: "https://www.facebook.com/swvdems",
    twitter: "https://x.com/swvdems",
    instagram: "https://www.instagram.com/swvolusiadems/",
    youtube: "https://www.youtube.com/@SWVDems",
    bluesky: ""
  },

  // External URLs
  mobilizeUrl: "https://www.mobilize.us/swvdems",

  // Donation Links
  actBlueUrl: "https://secure.actblue.com/donate/swvdems",
  actBlueUrls: {
    membership: [],
    nonMembership: []
  },
  // Content
  description: "SW Democrats is dedicated to promoting Democratic values, supporting progressive candidates, and engaging our community in the democratic process.",

  timezone: 'America/New_York',
};

export default { brandConfig }; 

